export default "__VITE_ASSET__DfQ3vYfV__"